import { useState } from 'react';
import styles from './Card.module.css';
import LocationIcon from '../../assets/location.svg';
import Modal from "../Modal/Modal";
import DefaultImage from '../../assets/defaultImage.svg';

const Card = ({cardDetails}) => {
    const [showModal, setShowModal] = useState(false);
    return (
        <>
        <div className={styles.cardContainer} onClick={() => setShowModal(true)}>
            <div className={styles.imageContainer} style={{backgroundImage: cardDetails.image ? `url(${cardDetails.image})` : `url(${DefaultImage})`}}></div>
            <div className={styles.cardDetails}>
                <p className={styles.cardName}>{cardDetails.name}</p>
                <p className={styles.locationName}>{cardDetails.location.name ? cardDetails.location.name : cardDetails.address}</p>
                <div className={styles.distanceContainer}>
                    <img src={LocationIcon} alt="" />
                    <p className={styles.cardDistance}>{cardDetails.distance_from_location} Mi away</p>
                </div>
            </div>
        </div>
        <Modal showModal={showModal} setShowModal={setShowModal} />
        </>
    )
}

export default Card;